import { render, staticRenderFns } from "./DomainOppositionList.vue?vue&type=template&id=517e1536&"
import script from "./DomainOppositionList.vue?vue&type=script&lang=js&"
export * from "./DomainOppositionList.vue?vue&type=script&lang=js&"
import style0 from "./DomainOppositionList.vue?vue&type=style&index=0&id=517e1536&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports